import { SelectProps } from 'antd';

/** Search filter for `Select` component.
 * Filter `option.label` match the user type `input`.
 */
export const filterByLabel: SelectProps['filterOption'] = (input, option) =>
  String(option?.label).toLocaleLowerCase().includes(input.toLocaleLowerCase());
